import "./styles.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppProviders } from "./app/providers";
import { queryClient } from "./lib/api/query-client";
import { loadConfig } from "./lib/config";
import "./lib/i18n";
import { prefs } from "./lib/prefs";
import { initWebTelemetry } from "./lib/telemetry";
import { createAppRouter } from "./router";

async function boot() {
  prefs.apply();
  const cfg = await loadConfig();
  if (cfg.mock) {
    const { startMockWorker } = await import("./mocks/browser");
    await startMockWorker();
  }
  // OpenTelemetry + GlitchTip when /config.json asks for them (lazy chunks; nothing loads otherwise)
  const telemetry = await initWebTelemetry(cfg);
  const router = createAppRouter();
  createRoot(document.getElementById("root")!, telemetry.rootOptions).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppProviders>
          <RouterProvider router={router} />
        </AppProviders>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void boot();
